module.exports = __webpack_public_path__ + "media/images/emp/nist_logo_reverse-a51f825ee835f946535b9845106c78fc.png";